import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const message = ({ ...rest }) => MySwal.fire({
  ...rest,
  confirmButtonColor: '#2e59d9',
});

export default {
  message,
};
